/**
 * @Author Valon.Ye
 * @Date 2022/06/15 15:54:55
 * @FilePath \business\src\pages\Product\Review\List\models\review-list.ts
 * @Description
 */
import { useState, useCallback } from 'react'

import { useRouteQuery } from '@/utils/hooks'

import { parseUrl, parse } from 'query-string'

const useReviewListModel = () => {
  const query = parse(window.location.search, {
    parseNumbers: true,
    parseBooleans: true,
  })

  const [listUpdateTimes, setListUpdateTimes] = useState(0)
  const [selectedTab, changeSelectedTab] = useState<number>((query.tab as number) || 0)

  const handleSelectTab = useCallback((index) => {
    changeSelectedTab(index)
  }, [])

  return {
    listUpdateTimes,
    increaseListUpdateTimes: () => setListUpdateTimes(listUpdateTimes + 1),
    selectedTab,
    handleSelectTab,
  }
}

export default useReviewListModel
